import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UserService} from '../services/user.service';

export const MS_PREFIXES = ['api/is/', 'api/debt/', 'api/common/', 'api/transaction/', 'api/pipeline/', 'api/search/'];

/**
 * Attaches the X-Active-Team-Id header to outbound microservice requests
 * so the backend resolves the correct team context without requiring a token refresh.
 * TM (`api/transaction/`) must receive this header or Company CA Signed falls back to
 * the JWT/default team instead of the Admin toggle for the header team.
 * Team "All" is 0 — still send it so Add Deal uses the employee office, not the default team.
 */
@Injectable()
export class ActiveTeamInterceptor implements HttpInterceptor {
  constructor(private readonly userService: UserService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const activeTeamId = this.userService.activeTeamId();
    // Team "All" is 0 — still send it so Add Deal uses the employee office, not the default team.
    if (activeTeamId == null) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({ setHeaders: {'X-Active-Team-Id': String(activeTeamId)} })
    );
  }
}
